import { toast } from "react-toastify";

function handleErrors(errors, field = "") {
  if (errors?.message) {
    return toast.error(errors.message);
  }

  if (Array.isArray(errors)) {
    const cleanedMessages = errors.map((msg) =>
      typeof msg === "string" ? msg.replace(/Full Name/gi, "Name") : msg
    );
    const joinedMessage = cleanedMessages.join(" ");

    const displayField = field === "full_name" ? "name" : field;

    if (displayField !== "non_field_errors") {
      toast.error(`${displayField}: ${joinedMessage}`);
    } else {
      toast.error(joinedMessage);
    }
  } else if (typeof errors === "object" && errors !== null) {
    Object.entries(errors).forEach(([key, value]) => {
      const newKey = key === "full_name" ? "name" : key;
      const newField = field ? `${field}.${newKey}` : newKey;
      handleErrors(value, newField);
    });
  } else if (typeof errors === "string") {
    toast.error(errors.replace(/Full Name/gi, "Name").slice(0, 150));
  }
}

export { handleErrors };
